<template>
  <div
    class="proa-tooltip-wrapper"
    @mouseover="onMouseOver"
    @mouseleave="onMouseLeave"
  >
    <div v-if="showTooltip" class="proa-tooltip">
      <slot name="tooltip"/>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ProaTooltip',
  props: {
    // TODO: placement
  },
  data() {
    return {
      showTooltip: false
    }
  },
  methods: {
    onMouseOver: function() {
      this.showTooltip = true
    },
    onMouseLeave: function() {
      this.showTooltip = false
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.proa-tooltip-wrapper {
  position: relative;
  z-index: auto;
}

.proa-tooltip {
  position: absolute;
  z-index: 1;
  bottom: calc(100% + 14px);
  left: 50%;
  padding: 5px 10px;
  transform: translateX(-50%);
  border-radius: 4px;
  background-color: $secondary-color;
  color: white;
  white-space: nowrap;

  &:before {
    content: "";
    position: absolute;
    top: 100%;
    left: calc(50% - 8px);
    border: 8px solid transparent;
    border-top: 10px solid $secondary-color;
  }
}
</style>
